<template>
    <v-container fluid class="admin-page">
        <!-- Header -->
        <div class="page-header">
            <div>
                <p class="page-kicker">Administration</p>
                <h1 class="page-title">Modifier l'utilisateur</h1>
                <p class="page-subtitle" v-if="user.prenom || user.nom">
                    {{ user.prenom }} {{ user.nom }} <span v-if="user.email">&mdash; {{ user.email }}</span>
                </p>
            </div>
            <v-btn variant="outlined" class="action-button" @click="$router.go(-1)">
                <v-icon start>mdi-arrow-left</v-icon> Retour
            </v-btn>
        </div>

        <user-edit-info
            @userFetched="handleFetchedUser"
            @load="loadingChange"
            :isLoading="isLoading"
            :userId="userId"
        ></user-edit-info>

        <div class="my-4"></div>

        <user-password
            :userId="userId"
            :resetPassword="true"
            :isLoading="isLoading"
            @load="loadingChange"
        ></user-password>

        <div class="my-4"></div>

        <!-- Danger zone -->
        <v-card variant="outlined" v-if="canBeDeleted" class="section-card danger-card">
            <div class="section-card-header">
                <v-avatar size="34" color="#fee2e2" class="section-icon">
                    <v-icon color="#dc2626">mdi-alert-octagon-outline</v-icon>
                </v-avatar>
                <div>
                    <h2 class="section-title">Zone de danger</h2>
                    <p class="section-subtitle">La suppression de ce compte est définitive et irréversible.</p>
                </div>
                <v-spacer></v-spacer>
                <v-btn theme="dark" color="#dc2626" class="action-button" @click="dialog = true">
                    <v-icon start>mdi-trash-can-outline</v-icon> Supprimer
                </v-btn>
            </div>
        </v-card>

        <v-dialog v-if="canBeDeleted" v-model="dialog" width="auto">
            <user-delete :userId="userId" @cancel="dialog = false"></user-delete>
        </v-dialog>

        <v-overlay :model-value="isLoading" class="align-center justify-center" z-index="6">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
import UserDelete from '../../../components/User/UserDelete.vue';
import UserEditInfo from '../../../components/User/UserEditInfo.vue';
import UserPassword from '../../../components/User/UserPassword.vue';

export default {
    name: 'UserEdit',
    components: { UserEditInfo, UserPassword, UserDelete },
    data() {
        return {
            isLoading: false,
            dialog: false,
            userId: this.$route.params.userId,
            user: {
                prenom: '',
                nom: '',
                matricule: '',
                email: '',
                etablissement: null,
                role: '',
                etablissement_id: 0
            }
        };
    },
    computed: {
        canBeDeleted() {
            return this.user.role !== this.$store.state.auth.user.role;
        }
    },
    methods: {
        handleFetchedUser(user) {
            this.user = user;
        },
        loadingChange(load) {
            this.isLoading = load;
        }
    }
};
</script>

<style scoped>
.admin-page {
    max-width: 100%;
}
.page-header {
    align-items: center;
    display: flex;
    gap: 24px;
    justify-content: space-between;
    margin-bottom: 12px;
}
.page-kicker {
    color: #64748b;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    margin: 0 0 4px;
    text-transform: uppercase;
}
.page-title {
    color: #0f172a;
    font-size: 1.3rem;
    font-weight: 800;
    letter-spacing: 0;
    line-height: 1.2;
    margin: 0;
}
.theme--dark .page-title {
    color: #f8fafc;
}
.page-subtitle {
    color: #64748b;
    font-size: 0.9rem;
    margin: 4px 0 0;
}
.action-button {
    border-radius: 8px;
    box-shadow: none;
    height: 36px;
    text-transform: none;
}
.section-card {
    border-radius: 12px;
}
.danger-card {
    border-color: #fecaca !important;
}
.theme--dark .danger-card {
    border-color: #7f1d1d !important;
}
.section-card-header {
    align-items: center;
    display: flex;
    gap: 16px;
    padding: 12px 16px;
}
.section-title {
    font-size: 0.95rem;
    font-weight: 700;
    line-height: 1.3;
    margin: 0;
}
.section-subtitle {
    color: #64748b;
    font-size: 0.85rem;
    margin: 2px 0 0;
}
@media (max-width: 900px) {
    .page-header {
        align-items: stretch;
        flex-direction: column;
    }
    .section-card-header {
        align-items: stretch;
        flex-direction: column;
    }
}
</style>
